module.exports = __webpack_public_path__ + "img/places.0546fd98.svg";